export const variantMapping = {
    display: 'h1',
    'page-title': 'h2',
    title: 'h3',
    subtitle: 'h4',
    header: 'h5',
    subheader: 'h6',
    'mini-header': 'h6',
    'body-bold': 'p',
    'body-large': 'p',
    'body-medium': 'p',
    'body-small': 'p',
    caption: 'span',
    'caption-bold': 'span',
    'button-default': 'span',
    'button-regular': 'span'
} as const

export type TypographyVariant = keyof typeof variantMapping